import defaultTheme from './default';
import type { IConfirmationTheme } from './types/IConfirmation';

export const ConfirmationTheme: IConfirmationTheme = {
  ...defaultTheme,
  defaultDarkColor: 'var(--dark, #000000 )',
};
